import { useEffect } from "react"
import { enterSession, leaveSession, type AnalyticsApp } from "./analytics"

/** Tag all events with the session id and app while a session page is mounted. */
export function useSessionAnalytics(app: AnalyticsApp, sessionId: string): void {
  useEffect(() => {
    if (!sessionId) return
    enterSession(app, sessionId)
    return leaveSession
  }, [app, sessionId])
}
